import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { until } from 'protractor';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ITaskForm } from 'src/app/components/task-form/task-form.component';
import { DataService } from 'src/app/services/data/data.service';
import { TaskService } from 'src/app/services/task/task.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.sass']
})
export class CreateTaskComponent implements OnInit, OnDestroy {

  /** ID if it's updating task */
  id: string

  taskObj: ITaskForm

  formValid: boolean = false
  currLoc: any
  unsubber: Subject<boolean> = new Subject<boolean>()

  constructor(
    private taskServ: TaskService,
    public route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private _t: TranslateService,
    private dataService: DataService,
    private locationStore: LocationStoreService
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe(params => {
        const { id } = params

        if (!id) return

        this.populateForm(id)
      })
  }

  ngOnDestroy(): void {
    this.unsubber.next(true)
    this.unsubber.unsubscribe()
  }

  async populateForm(id: string) {
    this.taskServ.findOne(id).pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe(res => {
        this.id = id

        const fixing_date = this.datePipe.transform(new Date(res.fixing_date), 'yyyy-MM-dd')
        this.taskObj = { ...res, fixing_date: fixing_date, annotation: res?.annotation?.id }
      }
        , err => {
          this.id = null
          console.error('taskServe.findOne().err: ', err)
        }
      )
  }

  async onFormSubmit(evt?: any) {
    this.spinner.show()
    if (this.id) {
      this.taskServ.update(this.id, evt).pipe(takeUntil(this.unsubber.asObservable()))
        .subscribe(res => {
          this.spinner.hide()
          this.back()
        }, ({ error }) => {
          this.spinner.hide()
          const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
          this.toastr.error(this._t.instant(msg), this._t.instant('Error'));
        })
    }
    else {
      this.taskServ.create(evt).pipe(takeUntil(this.unsubber.asObservable()))
        .subscribe(res => {
         this.locationStore.currLocation$.pipe(takeUntil(this.unsubber.asObservable())).subscribe(res =>{
          this.currLoc = res;
          if (this.currLoc.tasks?.length){
            delete this.currLoc.tasks
            // deletes the currloc by refference on list task but not here and refreshes the list
          }
         }) 
          this.spinner.hide()
          this.back()

        }, ({error}) => {
          this.spinner.hide()
          // const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
          this.toastr.error(this._t.instant(error.message), this._t.instant('Error'));
        })
    }
  }

  async back() {
    const parent = this.id ? '../../' : '../'
    await this.router.navigate([parent], {
      relativeTo: this.route
    })
  }

}
